export type SendListenEvent = (event: "episode_finished", props: Record<string, string>) => void;

const sendToPlausible: SendListenEvent = (event, props) => {
    const plausible = (window as { plausible?: (name: string, options?: { props: Record<string, string> }) => void })
        .plausible;
    plausible?.(event, { props });
};

/**
 * Counts an episode played to its end, split by whether the listener was signed in. Nothing about the
 * episode, the show or the listener goes in the event: it answers how many reach the end, not who.
 */
export const trackEpisodeFinished = (signedIn: boolean, send: SendListenEvent = sendToPlausible) =>
    send("episode_finished", { signed_in: String(signedIn) });
